export default __webpack_public_path__ + "static/media/Incontent_Bannerdesktop.6589bc98.webp";